import { News } from './../news.model';
import { NewsService } from 'src/app/pages/news/news.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DecodeData } from 'src/app/shared/models/decode.model';
import { EncodeData } from 'src/app/shared/models/encode.model';

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.css']
})
export class NewsDetailComponent implements OnInit {

  public news: News;

  constructor(
    public newsServ:NewsService,
    public aRoute:ActivatedRoute,
    public auth:AuthService,
    public navigator:Router,
  ) { }

  ngOnInit() {
    this.newsServ.getObject('news').subscribe(news=>this.news=news)
  }

  editNews(){
    this.navigator.navigate(['/admin/news/edit'])
  }
}
